import createParseMiddleware from './createParseMiddleware';
import { parseUserActivityResponse, parseUserActivityTypeResponse } from 'utils/apiParser/userActivityParser';
import { UserActivity, UserActivityType } from 'types/userActivityTypes';

export const parseFetchUserActivitiesMiddleware = createParseMiddleware<UserActivity>(parseUserActivityResponse, 'userActivity/fetchUserActivities');
export const parseFetchUserActivityTypesMiddleware = createParseMiddleware<UserActivityType>(parseUserActivityTypeResponse, 'userActivity/fetchUserActivityTypes');
